import styled from 'styled-components';
import AddButton from 'components/Buttons/AddButton';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div``;

// TODO: TFR-44 move to container group
export const LoaderContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow:
    0rem 0.5rem 1rem rgba(35, 35, 35, 0.02),
    0rem 0.5rem 2rem rgba(35, 35, 35, 0.02);
  border-radius: 1.5rem;
  padding: 0.25rem;
  margin-bottom: 2rem;
`;

// TODO: TFR-45:Button make unique name or do not export
export const Button = styled(AddButton)`
  margin-bottom: 2rem;
`;
